import React from 'react'
import { Flex, Spacer, Grid } from '@jisr-hr/design-system'
import { SelectField, DatePickerDSField } from 'components/final-form'
import { useSelector } from 'react-redux'
import { useFormState, useForm } from 'react-final-form'
import { required } from 'components/global/form/FormValidations'
import I18n from 'translations/i18n'
import { subDays } from 'date-fns'

import Frame from '../../../ds/Frame'

const LeaveDetails = (props) => {
  const { isAnnual, isHalfDay } = props
  const { leave_types } = useSelector(({ employeeLeaveTypes }) => employeeLeaveTypes)
  const { values } = useFormState()
  const { change } = useForm()

  return (
    <Frame title={I18n.t('leave_details')}>
      <Flex flexCol>
        <SelectField
          validate={required}
          name="leave_type_id"
          testId="leave-type"
          placeholder={I18n.t('select')}
          labelKey="name"
          valueKey="id"
          options={leave_types}
          label={I18n.t('type')}
          style={{ width: '100%' }}
          maxMenuHeight={256}
          menuPosition="default"
        />
        <Spacer height={16} />
        {(!isAnnual || (isAnnual && !isHalfDay)) && (
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={6}
              data-testid="select-start-date"
            >
              <DatePickerDSField
                validate={required}
                name="from"
                placeholder={I18n.t('select_date')}
                label={I18n.t('start')}
                onChange={() => change('to', null)}
                minDate={subDays(new Date(), 59)}
              />
            </Grid>
            <Grid
              item
              xs={6}
              data-testid="select-end-date"
            >
              <DatePickerDSField
                validate={required}
                name="to"
                placeholder={I18n.t('select_date')}
                label={I18n.t('end')}
                minDate={new Date(values?.from)}
                disabled={!values?.from}
              />
            </Grid>
          </Grid>
        )}
      </Flex>
    </Frame>
  )
}

export default LeaveDetails
